import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=6029ba25&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6029ba25')) {
      api.createRecord('6029ba25', component.options)
    } else {
      api.reload('6029ba25', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=6029ba25&", function () {
      api.rerender('6029ba25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/v2charts/BarChart.vue"
export default component.exports